import { IDateInputControl } from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../../infrastructure/providers/abstract/IApiProvider';
import { NamedDomain } from '../../../../infrastructure/schemas/storage/NamedDomain';
import {
  DateFormControlViewModel,
  FormControlViewModelType,
  LocalizedProps,
} from '../../view-model/FormControlViewModel';
import { FormSource, FormSourceType } from '../../view-model/FormSource';

import { getDateFormatProps, getValueFromArgsOrConfig } from './helpers';

const buildDateControl = (
  domain: NamedDomain,
  item: IDateInputControl,
  localizedProps: LocalizedProps,
  source: FormSource,
  args: TActionArgsValues
): DateFormControlViewModel => {
  const formatProps = getDateFormatProps(domain);

  let value = getValueFromArgsOrConfig<Date | null>(item, args, source, null);
  if (value !== null) {
    value = new Date(value);
  }

  return {
    columns: item.columns,
    disabled: item.disabled,
    hasHistory: false,
    hasValue: true,
    invalid: item.invalid,
    errorMessage: item.errorMessage,
    labelWidth: item.labelWidth,
    name: item.name,
    noLabel: item.noLabel,
    readonly: item.readonly || source.type === FormSourceType.REVIEW,
    required: item.required,
    storeValue: item.storeValue,
    type: FormControlViewModelType.DATE,
    updater: item.updater,
    value,
    visible: item.visible,
    ...formatProps,
    ...localizedProps,
  };
};

export default buildDateControl;
